import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import * as firebase from 'firebase'

const firebaseConfig = {
  apiKey: "AIzaSyC1D5t5nJlu-_QdJrT2x2K835pLSZKQPQk",
  authDomain: "superfiction-9068f.firebaseapp.com",
  databaseURL: "https://superfiction-9068f.firebaseio.com",
  projectId: "superfiction-9068f",
  storageBucket: "superfiction-9068f.appspot.com",
  messagingSenderId: "392723526749",
  appId: "1:392723526749:web:194db23d79b2069eeb49b4",
  measurementId: "G-25VJQXSDS4"
};
firebase.initializeApp(firebaseConfig);
firebase.analytics();

createApp(App).use(router).use(router).mount('#app')
